// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".instructions-area {\n  padding: 5px;\n  text-align: center;\n  overflow: auto;\n}\n\n.no-selection-needed {\n  color: 'var(--accent-color)'\n}\n", ""]);
// Exports
module.exports = exports;
